import { useState } from "react";
import { HandleNameChangeInterface, IMessage } from "../types/Types";
import firebase from "./../Firebase";
import useContextMenu from "react-use-context-menu";

const ChatMessage: React.FC<IMessage> = ({ photoURL, displayName, text, uid, img, id, isLiked, deleteMessage, changeMessage, setMessageLike }) => {
  const [toggle, setToggle] = useState(true);
  const [newMessage, setMessage] = useState(text);
  const [bindMenu, bindMenuItems, useContextTrigger, { setVisible }] = useContextMenu();
  const [bindTrigger] = useContextTrigger();

  const messageClassName = uid === firebase.auth().currentUser?.uid ? "message-item-user" : "";

  function hideMenu() {
    setVisible(false);
  }

  function typeMessage(event: HandleNameChangeInterface) {
    setMessage(event.target.value);
  }

  return (
    <>
      <div
        onDoubleClick={() => {
          setMessageLike(id, isLiked);
        }}
        className={`message-item ${messageClassName}`}
      >
        <nav {...bindMenu} className="sub-menu-container">
          <div {...bindMenuItems} className="sub-menu-item" onClick={(event) => deleteMessage(id, uid, event)}>
            Delete
          </div>
          <div {...bindMenuItems} className="sub-menu-item" onClick={() => [setToggle(false), hideMenu()]}>
            Edit
          </div>
        </nav>

        <img className="message-img" src={photoURL || "default-avatar.png"} alt="" />
        <div {...bindTrigger} className="user-container">
          <div className="message-text">
            <p className="user-name">{displayName}</p>
            {img && <img className="user-img" src={img} alt="" />}

            {toggle ? (
              <p>{text}</p>
            ) : (
              <input
                className="change-message-input"
                type="text"
                onChange={typeMessage}
                value={newMessage}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    changeMessage(id, uid, newMessage, event);
                    setToggle(true);
                    event.preventDefault();
                    event.stopPropagation();
                  }
                }}
              />
            )}
            {isLiked && <img className="heart-img" src="/like.svg" alt="" width="20" />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatMessage;
